export const PermissionsForRoute = {
  view: 1,
  create: 2,
  update: 4,
  delete: 8,
  resync: 32,
};
